import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjHorizonS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.5 7.10413C2.5 7.10413 2 10.1041 2 10.1041L2 7.10413C4 5.93746 7.29928 3.46398 10.5 4.10413C12.5 4.50413 13.6667 5.93746 14 6.60413V10.1041C14 10.1041 10.5 7.10413 6.5 7.10413Z"
        fill="currentcolor"
      />
      <path
        d="M2.5 11.5C2.5 11.5 2.5 9 6.5 9C10.5 9 13.5 12 13.5 12"
        stroke="currentcolor"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  )
}

export const IconGeoObjHorizon = createIcon({
  l: IconGeoObjHorizonS,
  m: IconGeoObjHorizonS,
  s: IconGeoObjHorizonS,
  xs: IconGeoObjHorizonS,
  name: 'IconGeoObjHorizon',
})
